import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Action } from 'redux';

import { LegalDocumentKey } from '../../../domain/config';
import { RootState } from '../../../store';
import { DataLoadState, ErrorType, initialDataLoadState } from '../../../store/reducers/common';

type SaveConsentState = DataLoadState;

const initialState: SaveConsentState = initialDataLoadState;

const slice = createSlice({
  name: 'record-consent',
  initialState,
  reducers: {
    recordConsent: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: PayloadAction<{
        documentKeys: LegalDocumentKey[];
        onSuccess: Action[];
      }>,
    ) => {
      const updated: typeof state = {
        ...state,
        loading: true,
        error: null,
      };
      return updated;
    },
    recordOfferConsent: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: PayloadAction<{
        offerId: string;
        onSuccess: Action[];
      }>,
    ) => ({
      ...state,
      loading: true,
      error: null,
    }),
    recordConsentSuccess: (state) => ({
      ...state,
      loading: false,
      error: null,
    }),
    recordConsentFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
  },
});

export const consentReducer = slice.reducer;
export const { recordConsent, recordOfferConsent, recordConsentFail, recordConsentSuccess } = slice.actions;

export const selectConsent = (state: RootState) => state.consent;
